import {useEffect, useState} from 'react';
import {changedDocumentService} from '../../services';
import {StringIndexedObject} from './Types';
import {useFormbird} from '../../formbird/FormbirdContext';

type FieldMapping = { [p: string]: string };

export const useWatchedFields = <Data>(fieldMapping: FieldMapping): Data => {
    const { document, registeredControlName } = useFormbird();

    const [data, setData] = useState<Data>(() => {
        const newData: StringIndexedObject = {};
        for (const [key, value] of Object.entries(fieldMapping)) {
            newData[value] = document?.[key];
        }
        return newData as Data;
    });

    useEffect(() => {
        const docSubs = Object.keys(fieldMapping).map((fieldName) => {
            return changedDocumentService.watch(fieldName, document.documentId, registeredControlName)
                .subscribe((newValue) => {
                    setData((prevState) => {
                        const prev = structuredClone(prevState) as StringIndexedObject;
                        prev[fieldMapping[fieldName]] = newValue;
                        return prev as Data;
                    });
                });
        });

        return () => docSubs.forEach(sub => sub.unsubscribe());
    }, []);

    return data;
};

export const useDefinition = (callback: Function) => { 
    const { template, fieldName } = useFormbird();
    const [compDef, setCompDef] = useState(template.components?.find(c => (c.name ===fieldName)));

    useEffect(() => {
        const docSub = changedDocumentService.watchComponentDef(fieldName, template.documentId)
        .subscribe((newValue: any) => {
            setCompDef(newValue);
            console.log('useDefinition', newValue);
            callback(newValue);
        });
        return () => docSub.unsubscribe();
    }, []);
    return compDef;
};
